<template>
  <section class="not-found">
    <div class="content-wrap">
      <h1>404</h1>
      <h4>Sorry we could not find the page you requested.</h4>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .not-found {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    position: relative;
  }

  .content-wrap {
    position: absolute;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    top: 50%;
    left: 50%;
  }

  h1 {
    font-size: 170px;
    line-height: 1;
  }

  h1, h4 {
    margin: 0;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue